import React from "react";
import { FormControlLabel, Switch } from "@material-ui/core";

const SimpleSwitch = ({
  id,
  name,
  label,
  labelPos = "top",
  value,
  onChange,
  disabled,
  onBlur,
  error,
  helperText,
}) => {
  return (
    <FormControlLabel
      label={label}
      labelPlacement={labelPos}
      control={
        <Switch
          id={id}
          name={name}
          disabled={disabled}
          checked={value}
          onChange={({ target }) =>
            onChange({ target: { name, value: target.checked } })
          }
        />
      }
    />
  );
};

export default SimpleSwitch;
